export const messages = {
	en: {
		'due-date-calculator.action.calculate': 'Calculate my due date',
		'due-date-calculator.action.recalculate': 'Recalculate',
		'due-date-calculator.disclaimer':
			'This calculator is for informational purposes only. It is not intended to imply and does not guarantee that you will achieve pregnancy as a patient of Everleap Fertility. Results vary by patient. Please consult your care team about your individual circumstances.',
		'due-date-calculator.error.date.invalid': 'Enter a valid calendar date.',
		'due-date-calculator.error.date.required': 'Select a transfer date.',
		'due-date-calculator.error.summary': 'Please correct the highlighted fields.',
		'due-date-calculator.error.transfer-type.required': 'Select a transfer type.',
		'due-date-calculator.form.date.label': 'Date of transfer',
		'due-date-calculator.form.date.placeholder': 'YYYY-MM-DD',
		'due-date-calculator.form.title.line-1': 'IVF and FET',
		'due-date-calculator.form.title.line-2': 'Due Date Calculator',
		'due-date-calculator.form.transfer-type.label': 'Type of transfer',
		'due-date-calculator.form.transfer-type.placeholder': 'Transfer type',
		'due-date-calculator.gestational-age.future':
			'Gestational age will be available after the estimated pregnancy start date.',
		'due-date-calculator.gestational-age.passed':
			'This estimated due date appears to have passed.',
		'due-date-calculator.gestational-age.phrase':
			'You are {age} pregnant{passed}',
		'due-date-calculator.gestational-age.join': ' and ',
		'due-date-calculator.gestational-age.week.one': '{count} week',
		'due-date-calculator.gestational-age.week.other': '{count} weeks',
		'due-date-calculator.gestational-age.day.one': '{count} day',
		'due-date-calculator.gestational-age.day.other': '{count} days',
		'due-date-calculator.gestational-age.zero': '0 days',
		'due-date-calculator.result.accessible-date':
			'Your expected delivery date is {date}',
		'due-date-calculator.result.title': 'Your expected delivery date is',
		'due-date-calculator.result.range-separator': 'to',
		'due-date-calculator.transfer-type.fresh-lh-surge':
			'Fresh Embryo Transfer - LH Surge Date',
		'due-date-calculator.transfer-type.frozen-day-5-6-7':
			'Frozen Embryo Transfer - Day 5, Day 6, Day 7',
		'due-date-calculator.transfer-type.lmp-natural-iui':
			'First day of your last menstrual period (Natural conception, fertility drugs or IUI)',
		'due-date-calculator.trimester.first': 'First trimester',
		'due-date-calculator.trimester.second': 'Second trimester',
		'due-date-calculator.trimester.third': 'Third trimester',
	},
	es: {
		'due-date-calculator.action.calculate': 'Calcular mi fecha de parto',
		'due-date-calculator.action.recalculate': 'Recalcular',
		'due-date-calculator.disclaimer':
			'Esta calculadora tiene fines exclusivamente informativos. No pretende implicar ni garantiza que logre un embarazo como paciente de Everleap Fertility. Los resultados varían según cada paciente. Consulte con su equipo de atención sobre sus circunstancias particulares.',
		'due-date-calculator.error.date.invalid': 'Introduce una fecha valida.',
		'due-date-calculator.error.date.required':
			'Selecciona una fecha de transferencia.',
		'due-date-calculator.error.summary':
			'Corrige los campos destacados para continuar.',
		'due-date-calculator.error.transfer-type.required':
			'Selecciona un tipo de transferencia.',
		'due-date-calculator.form.date.label': 'Fecha de transferencia',
		'due-date-calculator.form.date.placeholder': 'AAAA-MM-DD',
		'due-date-calculator.form.title.line-1': 'IVF and FET',
		'due-date-calculator.form.title.line-2': 'Calculadora de fecha de parto',
		'due-date-calculator.form.transfer-type.label': 'Tipo de transferencia',
		'due-date-calculator.form.transfer-type.placeholder': 'Tipo de transferencia',
		'due-date-calculator.gestational-age.future':
			'La edad gestacional estara disponible despues de la fecha estimada de inicio del embarazo.',
		'due-date-calculator.gestational-age.passed':
			'Esta fecha estimada de parto parece haber pasado.',
		'due-date-calculator.gestational-age.phrase':
			'Tienes {age} de embarazo{passed}',
		'due-date-calculator.gestational-age.join': ' y ',
		'due-date-calculator.gestational-age.week.one': '{count} semana',
		'due-date-calculator.gestational-age.week.other': '{count} semanas',
		'due-date-calculator.gestational-age.day.one': '{count} dia',
		'due-date-calculator.gestational-age.day.other': '{count} dias',
		'due-date-calculator.gestational-age.zero': '0 dias',
		'due-date-calculator.result.accessible-date':
			'Tu fecha estimada de parto es {date}',
		'due-date-calculator.result.title': 'Tu fecha estimada de parto es',
		'due-date-calculator.result.range-separator': 'a',
		'due-date-calculator.transfer-type.fresh-lh-surge':
			'Transferencia de embrion fresco - fecha de pico LH',
		'due-date-calculator.transfer-type.frozen-day-5-6-7':
			'Transferencia de embrion congelado - dia 5, dia 6, dia 7',
		'due-date-calculator.transfer-type.lmp-natural-iui':
			'Primer dia de la ultima menstruacion (concepcion natural, farmacos de fertilidad o IUI)',
		'due-date-calculator.trimester.first': 'Primer trimestre',
		'due-date-calculator.trimester.second': 'Segundo trimestre',
		'due-date-calculator.trimester.third': 'Tercer trimestre',
	},
};

export function getLocale() {
	const liferayLanguageId = window.Liferay?.ThemeDisplay?.getLanguageId?.();

	if (liferayLanguageId) {
		return liferayLanguageId.replace('_', '-');
	}

	return document.documentElement.lang || 'en-US';
}

export function getLanguageKey(locale = getLocale()) {
	return locale.toLowerCase().startsWith('es') ? 'es' : 'en';
}

export function translate(key, replacements = {}, locale = getLocale()) {
	const liferayTranslation = window.Liferay?.Language?.get?.(key);

	let text =
		liferayTranslation && liferayTranslation !== key
			? liferayTranslation
			: messages[getLanguageKey(locale)][key] || messages.en[key] || key;

	Object.entries(replacements).forEach(([name, value]) => {
		text = text.replace(`{${name}}`, value);
	});

	return text;
}

export function formatGestationalAge(result, t) {
	const messages = formatGestationalAgeMessages(result, t);

	return [messages.primary, messages.secondary].filter(Boolean).join(' ');
}

export function formatGestationalAgeMessages(result, t) {
	if (result.gestationalAgeDays < 0) {
		return {
			primary: t('due-date-calculator.gestational-age.future'),
			secondary: '',
		};
	}

	const parts = [];

	if (result.gestationalWeeks > 0) {
		parts.push(
			t(
				result.gestationalWeeks === 1
					? 'due-date-calculator.gestational-age.week.one'
					: 'due-date-calculator.gestational-age.week.other',
				{count: result.gestationalWeeks}
			)
		);
	}

	if (result.gestationalDays > 0) {
		parts.push(
			t(
				result.gestationalDays === 1
					? 'due-date-calculator.gestational-age.day.one'
					: 'due-date-calculator.gestational-age.day.other',
				{count: result.gestationalDays}
			)
		);
	}

	const age = parts.length
		? parts.join(t('due-date-calculator.gestational-age.join'))
		: t('due-date-calculator.gestational-age.zero');
	const secondary =
		result.gestationalAgeDays > 294
			? t('due-date-calculator.gestational-age.passed')
			: '';

	return {
		primary: t('due-date-calculator.gestational-age.phrase', {
			age,
			passed: '',
		}),
		secondary,
	};
}
